import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { setIsInteracting } from "store/user/slice";
import { isMobile } from "react-device-detect";

export function useInteractivityListeners(elementClassName: string) {
  const dispatch = useDispatch();
  const { isInteracting } = useSelector((s: RootState) => s.user);

  /** Attach move and touch event listeners */
  useEffect(() => {
    function listener() {
      if (!isInteracting) {
        dispatch(setIsInteracting(true));
        setTimeout(() => {
          dispatch(setIsInteracting(false));
        }, 5000);
      }
    }

    if (!isMobile) {
      const element = document.getElementsByClassName(elementClassName)[0];
      element.addEventListener("mousemove", listener);
      return () => {
        element.removeEventListener("mousemove", listener);
      };
    } else {
      if (!isInteracting) {
        dispatch(setIsInteracting(true));
      }
    }
  }, [dispatch, elementClassName, isInteracting]);
}
